import { ChangeEvent, forwardRef } from 'react'
import { InputTextProps } from './Input_Text'
import { Input, TextInputProps } from '@mantine/core'
import { Controller, useFormContext } from 'react-hook-form'
import { TbPhone } from 'react-icons/tb'

const formatPhoneValue = (value: string) =>
  value
    .replace(/\D/g, '')
    .slice(0, 9)
    .match(/.{1,3}/g)
    ?.join('-') ?? ''

export const InputPhonePure = forwardRef<
  HTMLInputElement,
  Omit<TextInputProps, 'value' | 'ref' | 'icon'> & { value?: string }
>(
  (
    { wrapperProps, required, label, error, onChange, value, leftSection },
    ref,
  ) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      onChange?.(formatPhoneValue(event.currentTarget.value) as never)
    }

    return (
      <Input.Wrapper
        required={required}
        label={label}
        error={error}
        {...(wrapperProps as Record<string, unknown>)}
      >
        <Input
          data-invalid={!!error}
          ref={ref}
          onChange={handleChange}
          value={value}
          leftSection={leftSection}
        />
      </Input.Wrapper>
    )
  },
)

InputPhonePure.displayName = 'TextInputPhonePure'

export const InputPhone = ({
  name,
  icon: Icon = TbPhone,
  className,
  ...props
}: InputTextProps) => {
  const { control } = useFormContext()
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { ref, ...field }, fieldState }) => {
        const { error } = fieldState
        return (
          <InputPhonePure
            {...field}
            {...props}
            ref={ref}
            className={className}
            error={error?.message}
            leftSection={Icon ? <Icon size={'1.2em'} /> : null}
          />
        )
      }}
    />
  )
}
